const OFF_COLOR = '000000';

export default OFF_COLOR;
